import React, { useEffect } from "react";
import styles from "./chatTaskInner.module.scss";
import usercircle from "../../../../styles/images/user-circle.svg";
import { PriorityBeam } from "../../../../shared/widgets/priorityBeam";
import { StatusTag } from "../../../../shared/widgets/statusTag";
import moment from "moment";
import { chatSideWindow } from "../../../../base/eventService/eventApiService";
import { toastInformation } from "../../../../base/callService/common";
import { eventService } from "../../../../base/eventService/event.service";
type taskDataProps ={
  taskData:any;
  searchedData?:any;
  viewData?:any;
}
export default function ChatTaskInner({taskData,searchedData,viewData}:taskDataProps) {
  useEffect(() => {

  }, [searchedData]);

  let message_text = taskData && taskData?.summary && taskData?.summary.length > 30
    ? taskData?.summary.substring(0, 28) + "..." : taskData?.summary || "";
  
  message_text= message_text?.replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/img,
    '<a href="$1" target="__blank">$1</a>');
  message_text = message_text?.replace(/\n/g, "<br />");
  if(searchedData!=="" && searchedData!== undefined && searchedData?.search(/[\[\]?*+|{}\\.\n\r]/) === -1){
    const regexs = new RegExp('('+searchedData+')', 'gi');
    message_text = message_text?.replace(regexs,
      '<span style="background-color:#FFFF00" tabindex="0" class="tranText">$1</span>');
  }

  const showTask = () => {

    new eventService().getTaskByUid(taskData?.uid)
      .then((response: any) => {
  
        if (response?.status === "Ok") { chatSideWindow(true, "edittask", response?.result); }
        else {
          toastInformation("That task was deleted", "failure");
        }
      })
      .catch((err: any) => {
        console.log("err--",err);
      })

  };
  
  return (
  <>
      <div className={`taskInner ${styles.taskMessage}`} onClick={showTask}>
        
        <div className={styles.taskHeader}>
          <div className={styles.taskStatus}>
            <span className={styles.taskTitle}>
              <span className={styles.iconTask}></span>
              <p dangerouslySetInnerHTML={{ __html: message_text?.replace(/\n/g, "<br />") }}></p>
            </span>
            <span className={styles.userCount}>
              {taskData?.attendee && Array.isArray(taskData?.attendee) && taskData?.attendee.length}
              <img src={usercircle} alt="" /></span>
          </div>
          <div className={styles.taskDetails}>
            <PriorityBeam className='priorityBeam bgGrey'/>
            <span className={styles.taskDate}>
              {taskData?.dtend && moment(new Date(taskData?.dtend * 1000)).format('ddd , MMM Do , YYYY')}</span>
            <div className={styles.reviewBtn}>
              {taskData?.taskStatus=== "In Review" ?
                <StatusTag className='statusunderReview' name='In Review' />
                : taskData?.taskStatus=== "On Hold" ?
                  <StatusTag className='statusHold' name='On Hold' />:
                  taskData?.taskStatus === "Completed"
                    ?
                    <StatusTag className='statusCompleted' name='Completed' />:
                    <StatusTag className='statusunderinProgress' name='In Progress' />
              }
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
